import axiosInstance from '@/api/axiosInstance'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const CERTIFICATIONS_PATH = '/certifications/'

export const useCertifications = () => {
    return useQuery({
        queryKey: ['certifications'],
        queryFn: async () => {
            const response = await axiosInstance.get(CERTIFICATIONS_PATH)
            return response.data.results || response.data
        },
        staleTime: 5 * 60 * 1000,
    })
}

export const useCreateCertification = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: any) => {
            const response = await axiosInstance.post(CERTIFICATIONS_PATH, data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['certifications'] })
        },
    })
}

export const useDeleteCertification = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (id: number) => {
            await axiosInstance.delete(`${CERTIFICATIONS_PATH}${id}/`)
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['certifications'] })
        },
    })
}


